<template>
  <div class="info-container" @click.stop.prevent="onClose">
    <div class="info-content">
      <div class="info-close-modal">
        <i class="fa fa-times"></i>
      </div>
      <div
        itemscope=""
        itemtype="http://schema.org/Product"
        id="product-info"
        class="product type-product status-publish has-post-thumbnail product_cat-apple-macbook product_cat-laptops first instock sale shipping-taxable purchasable product-type-simple"
      >
        <!-- <div class="seasidetms_product_sale_wrap">
          <i class="ico-bage" v-if="product.bage">
            {{ $t(`badge.${product.bage}`) }}
          </i>
        </div> -->
        <div class="images seasidetms_product_images">
          <div class="woocommerce-product-gallery__image">
            <a href="#" @click.stop.prevent="onGallery">
              <img
                width="429"
                height="429"
                class="wp-post-image"
                :src="productImgSrc"
                :alt="productName"
                :title="productName"
              />
            </a>
          </div>
        </div>
        <div class="summary entry-summary">
          <div class="summary-content">
            <div class="seasidetms_product_title_info_wrap">
              <div class="seasidetms_product_title_wrap">
                <h1 class="product_title entry-title">
                  {{ productName }}
                </h1>
              </div>
              <div class="seasidetms_product_info_wrap">
                <p class="price" v-if="product.newPrice">
                  <s>
                    <span style="margin-left: 50px" class="price-ukr">
                      <span v-html="$h.formatPrice(product.price)"></span>грн
                    </span>
                  </s>
                </p>
                <p class="price" v-if="product.newPrice">
                  <span
                    class="woocommerce-Price-amount amount"
                    style="color: rgba(255, 67, 0, 0.9)"
                  >
                  </span>
                  <span
                    style="margin-left: 50px; color: rgba(255, 67, 0, 0.9)"
                    class="price-ukr"
                  >
                    <span v-html="$h.formatPrice(product.newPrice)"></span>грн
                  </span>
                </p>
                <p class="price" v-else>
                  <span class="woocommerce-Price-amount amount"> </span>
                  <span style="margin-left: 50px" class="price-ukr">
                    <span v-html="$h.formatPrice(product.price)"></span>грн
                  </span>
                </p>
                <rating :rating="product.rating" />
              </div>
            </div>
            <div class="seasidetms_product_content product-short-description">
              {{ productDescription | stripHTML }}
            </div>
            <form class="cart" @submit.prevent>
              <div class="quantity" v-if="product.stock && !product.preorder">
                <label class="screen-reader-text" for="quantity">
                  {{ $t('quantity') }} {{ productName }}
                </label>
                <input
                  type="number"
                  id="quantity_number"
                  class="input-text qty text"
                  step="1"
                  min="1"
                  max=""
                  name="quantity"
                  value="1"
                  :title="$t('quantityShort')"
                  size="4"
                  inputmode="numeric"
                />
              </div>
              <button
                type="button"
                name="add-to-cart"
                class="single_add_to_cart_button button alt"
                @click.stop.prevent="onAddToCart"
                v-if="product.stock && !product.preorder"
              >
                {{ $t('addToCart') }}
              </button>
              <a
                id="preorder-click"
                class="kupit pum-trigger"
                style="cursor: pointer"
                @click.stop.prevent="onPreOrder"
                v-if="product.preorder"
              >
                {{ $t('preorder') }}
              </a>
              <a
                id="buy-in-one-click"
                class="kupit pum-trigger buy-one-click-info-modal"
                style="cursor: pointer"
                @click.stop.prevent="onQuickOrder"
                v-if="!product.preorder && product.stock"
              >
                {{ $t('buyOneClick') }}
              </a>
            </form>
            <!--<div class="product_meta">
              <span class="posted_in">
                <span class="product_meta_title">Categories: </span>
                <a
                  href="#/product-category/laptops/apple-macbook/"
                  class="seasidetms_cat_color seasidetms_cat_57"
                  rel="category tag"
                >
                  Apple Macbook
                </a>,
                <a
                  href="#/product-category/laptops/"
                  class="seasidetms_cat_color seasidetms_cat_35"
                  rel="category tag"
                >
                  Laptops
                </a>
              </span>
            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import Rating from '@/components/Rating'

export default {
  name: 'ProductInfoModal',
  components: { Rating },
  data() {
    return {
      qty: 1,
    }
  },
  computed: {
    productImgSrc() {
      return Array.isArray(this.product.img) && this.product.img.length
        ? `/img${this.product.img[0]}`
        : this.product.img
        ? `/img${this.product.img}`
        : '/img/uploads/error.png'
    },
    productImgSrcSet() {
      // extract missing w from filenames
      return this.product.srcset
        ? this.product.srcset
            .map((v) => {
              let m = v.match(/(\d+)x\d+\.(png|jpg|jpeg|gif)$/i)
              if (m && m.length > 1) {
                return `/img${v} ${m[1]}w`
              } else {
                return `/img${v} 75w`
              }
            })
            .join(',')
        : ''
    },
    productImgSizes() {
      return this.productImgSrcSet ? '(max-width: 540px) 100vw, 540px' : ''
    },
    productImgWidth() {
      if (
        this.product.srcset &&
        this.product.srcset.find((v) => v.match('540x540'))
      ) {
        return 540
      }
      return 410
    },
    productImgHeight() {
      if (
        this.product.srcset &&
        this.product.srcset.find((v) => v.match('580x410'))
      ) {
        return 410
      }
      return 415
    },
    productName() {
      return this.product[`name_${this.$i18n.locale}`]
        ? this.product[`name_${this.$i18n.locale}`]
        : this.product.name
        ? this.product.name
        : ''
    },
    productDescription() {
      if (
        this.product[`exc_${this.$i18n.locale}`] &&
        !this.product[`exc_${this.$i18n.locale}`].includes('</p>')
      ) {
        return this.product[`exc_${this.$i18n.locale}`]
      } else if (this.product[`description_${this.$i18n.locale}`]) {
        return this.product[`description_${this.$i18n.locale}`]
      } else if (this.product.description) {
        return this.product.description
      } else {
        return ''
      }
    },
    inCart() {
      return !!this.cart.items.find((item) => item.id === this.product._id)
    },
    ...mapState(['cart']),
    ...mapState({ product: (state) => state.productInfoModal }),
  },
  methods: {
    onClose(e) {
      if (
        e.target.className === 'info-container' ||
        e.target.className === 'fa fa-times'
      ) {
        this.$store.commit('setProductInfoModal', null)
      }
    },
    onGallery() {
      this.setGalleryModal(1)
    },
    onGallerySlide() {
      //TODO
    },
    onAddToCart() {
      let item = {}
      Object.assign(item, this.product, { single: true })
      this.addToCart(item)
        .then(() => {
          console.log('*ADDED')
          this.$store.commit('setProductInfoModal', null)
        })
        .catch(() => {
          console.log('*ERROR')
        })
    },
    onQuickOrder() {
      this.setQuickOrderModal(true)
      this.$store.commit('setProductModal', this.product)
      this.$store.commit('setProductInfoModal', null)
    },
    onPreOrder() {
      this.setPreOrderModal(true)
      this.$store.commit('setProductModal', this.product)
      this.$store.commit('setProductInfoModal', null)
    },
    onNotifyOnStock() {
      this.setNotifyStockModal(true)
      this.$store.commit('setProductModal', this.product)
      this.$store.commit('setProductInfoModal', null)
    },
    ...mapMutations([
      'setQuickOrderModal',
      'setPreOrderModal',
      'setNotifyStockModal',
      'setGalleryModal',
    ]),
    ...mapActions(['addToCart']),
  },
}
</script>

<style>
#product-info .images {
  float: left;
  width: 51%;
  /* padding: 0 40px 0 0;
  transform: translateY(50%); */
}
#product-info .summary {
  float: left;
  width: 49%;
  padding: 0;
  position: relative;
}
.info-container {
  position: fixed;
  display: flex;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999999999;
}
.info-content {
  position: relative;
  border-radius: 9px;
  width: 900px;
  min-height: 45vh;
  padding: 28px;
  background-color: #fff;
}
.info-close-modal {
  cursor: pointer;
  font-size: 28px;
  color: #fff;
  font-weight: bold;
  position: absolute;
  top: -28px;
  right: -28px;
}
#product-info .woocommerce-product-gallery__image {
  width: 80%;
  margin: 10px auto;
}
@media only screen and (max-width: 950px) {
  .info-content {
    width: auto;
    min-height: 90vh !important;
  }
}
/* woocommerce-product-details__short-description */
.product-short-description {
  max-height: 250px !important;
  overflow: hidden;
  margin-bottom: 20px;
  margin-top: 20px;
  display: -webkit-box;
  -webkit-line-clamp: 10;
  -webkit-box-orient: vertical;
}
@media only screen and (max-width: 768px) {
  .info-close-modal {
    font-size: 22px;
    font-weight: normal;
    top: 0;
    right: 6px;
    color: #444;
  }
  #product-info {
    display: flex;
    flex-direction: column;
    max-height: 640px;
  }
  #product-info .images {
    float: none;
    width: unset;
    padding: 0;
    transform: translateY(0);
  }
  #product-info .summary {
    float: none;
    width: unset;
  }
  .product-short-description {
    max-height: 168px !important;
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: 0 !important;
  }
}
</style>
